/**
 * Dashboard Loading State Component
 *
 * Displays skeleton loading states for dashboard sections
 */

import { clientConfig } from '@/config/clientConfig';
import { Card } from '@/shared/ui/card';

/**
 * Loading skeleton for KPI cards
 */
export function KpiLoadingSkeleton() {
  // Match the number of tiles KpiSection will actually render, so the row
  // doesn't shrink as the skeleton swaps out for real data (SC-6603).
  const tileCount =
    2 +
    (clientConfig.features.dashboardValueKpi ? 1 : 0) +
    (clientConfig.features.dashboardRiskKpi ? 1 : 0);

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {[...Array(tileCount)].map((_, i) => (
        <Card key={i} className="p-5" aria-hidden="true">
          <div className="space-y-3">
            <div className="h-4 w-24 animate-pulse rounded bg-gray-200" />
            <div className="h-8 w-32 animate-pulse rounded bg-gray-200" />
            <div className="h-3 w-20 animate-pulse rounded bg-gray-200" />
          </div>
        </Card>
      ))}
    </div>
  );
}

/**
 * Loading skeleton for chart cards
 */
export function ChartLoadingSkeleton() {
  return (
    <Card className="p-5" aria-hidden="true">
      <div className="space-y-4">
        <div className="h-6 w-48 animate-pulse rounded bg-gray-200" />
        <div className="h-64 animate-pulse rounded bg-gray-100" />
      </div>
    </Card>
  );
}

/**
 * Complete dashboard loading state
 */
export default function DashboardLoadingState() {
  return (
    <div className="space-y-6">
      {/* KPI Cards Loading */}
      <KpiLoadingSkeleton />

      {/* Charts Loading */}
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <ChartLoadingSkeleton />
        <ChartLoadingSkeleton />
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <ChartLoadingSkeleton />
        <ChartLoadingSkeleton />
      </div>
    </div>
  );
}
